module.exports = __webpack_public_path__ + "static/img/background.7704240d.svg";